import React from 'react';
import { InstagramIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-charcoal-950 text-offwhite-200 py-12 border-t border-charcoal-900" data-id="element-167" data-mp="3gfsn6dua2wni">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-168" data-mp="32o48c2sn9u2u">
        <div className="text-center md:text-left" data-id="element-169" data-mp="36oo5359b2vog">
          <a href="#" className="text-2xl font-bold text-offwhite-50 tracking-tight block mb-2" data-id="element-170" data-mp="36n3dnoiafsut">
            McLean <span className="text-amber-500" data-id="element-171" data-mp="38z8yrj06z2w">PT</span>
          </a>
          <p className="text-sm text-charcoal-500" data-id="element-172" data-mp="3lecaahklyehg">
            Physical Therapy & Performance Coaching · Camarillo, CA
          </p>
          <p className="text-sm text-offwhite-200 mt-3" data-id="element-173" data-mp="3qcniyoz62iy3">
            <span className="text-amber-500 font-medium" data-id="element-174" data-mp="3qf9sgu5mb8iy">
              In-person appointments:
            </span>{' '}
            House of Gains Gym, Camarillo, CA · By appointment only
          </p>
        </div>

        <div className="flex items-center space-x-6" data-id="element-175" data-mp="3l9adtjp9964y">
          <a href="https://www.instagram.com/mclean_physicaltherapy" target="_blank" rel="noopener noreferrer" className="text-charcoal-500 hover:text-amber-500 transition-colors" data-id="element-176" data-mp="3la288r748xtn">
            <InstagramIcon size={24} data-id="element-177" data-mp="3q8n2m9zosna6" />
            <span className="sr-only" data-id="element-178" data-mp="3q7lqs3aujwre">Instagram</span>
          </a>
          <a href="mailto:info@mcleanphysicaltherapy.com" className="text-charcoal-500 hover:text-amber-500 transition-colors" data-id="element-179" data-mp="82qt3uy8hxus">
            <MailIcon size={24} data-id="element-180" data-mp="31upzjlpifqf" />
            <span className="sr-only" data-id="element-181" data-mp="hsk2qqetg2we">Email</span>
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-8 pt-8 border-t border-charcoal-900 text-center md:text-left flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-charcoal-600" data-id="element-182" data-mp="ctqnasfyy1tl">
        <p data-id="element-183" data-mp="ms6ib6i49v8d">
          &copy; {new Date().getFullYear()} McLean Physical Therapy. All rights
          reserved.
        </p>
        <div className="flex space-x-4" data-id="element-184" data-mp="tvw8wk94jlhk">
          <a href="#" className="hover:text-offwhite-200 transition-colors" data-id="element-185" data-mp="tt08mp9t0kpy">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-offwhite-200 transition-colors" data-id="element-186" data-mp="13tan0d7kry6p">
            Terms of Service
          </a>
        </div>
      </div>
    </footer>;
}